// extracted by css-extract-rspack-plugin
export default {"search":"MRziPIejHAgmFHhS"};